import React, { useEffect, useState, useCallback } from 'react';
import { api } from '../api';

const emptyForm = { email: '', password: '', full_name: '', couple_names: '', wedding_date: '', event_slug: '' };

export default function AdminClients() {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const load = useCallback(async () => {
    const rows = await api.getClients();
    setClients(rows);
  }, []);

  useEffect(() => { load(); }, [load]);

  async function onCreate(e) {
    e.preventDefault();
    setError('');
    setCreating(true);
    try {
      await api.createClient(form);
      setForm(emptyForm);
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setCreating(false);
    }
  }

  async function toggleActive(client) {
    await api.updateClient(client.id, { active: client.active ? 0 : 1 });
    await load();
  }

  async function removeClient(client) {
    if (!window.confirm(`Fshi klientin "${client.full_name}"? Kjo fshin edhe të gjitha tavolinat dhe mysafirët e tij. Nuk kthehet mbrapa.`)) return;
    await api.deleteClient(client.id);
    await load();
  }

  return (
    <div className="clients-page">
      <h2>Klientët</h2>
      <p className="page-hint">Krijo një llogari për secilin klient. Ai kyçet vetë dhe menaxhon tavolinat/mysafirët e vet, plus ka QR kodin dhe linkun e vet unik.</p>

      <form className="client-form" onSubmit={onCreate}>
        <div className="form-row">
          <label>Emri i klientit / organizatorit
            <input required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} placeholder="p.sh. Ana Krasniqi" />
          </label>
          <label>Emrat e çiftit (për faqen publike)
            <input value={form.couple_names} onChange={(e) => setForm({ ...form, couple_names: e.target.value })} placeholder="p.sh. Ana & Dejan" />
          </label>
        </div>
        <div className="form-row">
          <label>Email kyçjeje
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="klienti@email.com" />
          </label>
          <label>Fjalëkalimi fillestar
            <input required type="text" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="të paktën 6 shkronja" />
          </label>
        </div>
        <div className="form-row">
          <label>Data e dasmës
            <input value={form.wedding_date} onChange={(e) => setForm({ ...form, wedding_date: e.target.value })} placeholder="p.sh. 12 Shtator 2026" />
          </label>
          <label>Slug për URL publike (opsionale)
            <input value={form.event_slug} onChange={(e) => setForm({ ...form, event_slug: e.target.value })} placeholder="p.sh. ana-dejan → /e/ana-dejan" />
          </label>
        </div>
        {error && <p className="login-error">{error}</p>}
        <button type="submit" disabled={creating}>{creating ? 'Duke krijuar…' : '+ Krijo Klient të Ri'}</button>
      </form>

      <table className="guests-table">
        <thead>
          <tr>
            <th>Klienti</th>
            <th>Çifti</th>
            <th>Email</th>
            <th>Tavolina</th>
            <th>Mysafirë</th>
            <th>Link publik</th>
            <th>Statusi</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {clients.map((c) => (
            <tr key={c.id}>
              <td>{c.full_name}</td>
              <td>{c.couple_names || '—'}</td>
              <td>{c.email}</td>
              <td>{c.tables_count}</td>
              <td>{c.guests_count}</td>
              <td><code>/e/{c.event_slug}</code></td>
              <td>
                <button className="pill-btn" onClick={() => toggleActive(c)}>
                  {c.active ? '✅ Aktiv' : '⏸ Joaktiv'}
                </button>
              </td>
              <td>
                <button className="danger-small" onClick={() => removeClient(c)}>✕</button>
              </td>
            </tr>
          ))}
          {clients.length === 0 && (
            <tr><td colSpan={8} className="empty-row">Ende s'ke krijuar asnjë klient.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
